import { render } from "./WeeklySales.vue?vue&type=template&id=20a74788&ts=true"
import script from "./WeeklySales.vue?vue&type=script&lang=ts"
export * from "./WeeklySales.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__